var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.alarmDetailVisible)?_c('AlarmDetail',{attrs:{"currentId":_vm.currentId},on:{"close":function($event){_vm.alarmDetailVisible = false}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }